module.exports = __webpack_public_path__ + "img/Mc.4907b9a4.png";